import "./view.scss";



function initSliders() {
    const containers = document.querySelectorAll('.wp-block-blueprint-slider');
    
    for (let i = 0; i < containers.length; i++) {
        const container = containers[i];
        const swiperNode = container.querySelector('.swiper');

        if (container.childElementCount && swiperNode) {
            // Get autoplay delay from data attribute, default to 5000ms
            const autoplayDelay = parseInt(container.getAttribute('data-autoplay-delay')) || 5000;
            
            const slider = new Swiper(swiperNode, {   
                direction: 'horizontal',
                autoplay: {
                    delay: autoplayDelay,
                    disableOnInteraction: false,
                },
                loop: true,                                                               
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: false,
                    bulletElement: 'button'
                },
                slidesPerView: 1,
                spaceBetween: 0,
            });

            // Add play/pause button functionality
            const playPauseButton = container.querySelector('.slider-toggle-button');
            if (playPauseButton) {
                const playIcon = playPauseButton.querySelector('.play-icon');
                const pauseIcon = playPauseButton.querySelector('.pause-icon');
                
                let isPaused = false;
                
                const updateButtonState = (paused) => {
                    isPaused = paused;
                    if (paused) {
                        playPauseButton.setAttribute('aria-label', 'Play slideshow');
                        playPauseButton.setAttribute('aria-pressed', 'false');
                        playIcon.style.display = 'block';
                        pauseIcon.style.display = 'none';
                    } else {
                        playPauseButton.setAttribute('aria-label', 'Pause slideshow');
                        playPauseButton.setAttribute('aria-pressed', 'true');
                        playIcon.style.display = 'none';
                        pauseIcon.style.display = 'block';
                    }
                };

                playPauseButton.addEventListener('click', () => {
                    if (isPaused) {
                        // Resume autoplay
                        slider.autoplay.start();
                        updateButtonState(false);
                    } else {
                        // Pause autoplay
                        slider.autoplay.stop();
                        updateButtonState(true);
                    }
                });

                slider.on('autoplayStart', () => {
                    updateButtonState(false);
                });

                slider.on('autoplayStop', () => {
                    updateButtonState(true);
                });

                updateButtonState(false);
            }
        }        
    }
}

document.addEventListener("DOMContentLoaded", function () {
    initSliders();
});